<template>
  <TooltipProvider :delay-duration="0">
    <TooltipRoot :open="open" @update:open="openChange">
      <TooltipTrigger type="button" :as="triggerAs">
        <slot name="trigger" :handleClick="handleClick"></slot>
      </TooltipTrigger>
      <TooltipPortal v-if="hasContent !== false && $slots.content">
        <TooltipContent
          class="data-[state=delayed-open]:data-[side=top]:animate-slideDownAndFade data-[state=delayed-open]:data-[side=right]:animate-slideLeftAndFade data-[state=delayed-open]:data-[side=left]:animate-slideRightAndFade data-[state=delayed-open]:data-[side=bottom]:animate-slideUpAndFade z-50 mx-3 max-w-full rounded-xl border bg-white text-[15px] leading-none shadow-lg will-change-[transform,opacity] lg:max-w-xl"
          :side="side"
          :side-offset="sideOffset"
          :class="{
            'px-5 py-5': !noPadding,
          }"
        >
          <div class="max-h-[50vh] overflow-y-auto">
            <slot name="content"></slot>
          </div>
          <TooltipArrow class="fill-white" :width="12" :height="8" />
        </TooltipContent>
      </TooltipPortal>
    </TooltipRoot>
  </TooltipProvider>
</template>

<script setup lang="ts">
import {
  TooltipArrow,
  TooltipContent,
  TooltipPortal,
  TooltipProvider,
  TooltipRoot,
  TooltipTrigger,
} from 'radix-vue';
import { getLogger } from '~/lib/services/getLogger';

const log = getLogger('Tooltip');
const open = ref(false);
const openChange = (v: boolean) => {
  open.value = v;
};
const handleClick = () => {
  log('Handle click');
  open.value = !open.value;
};

withDefaults(
  defineProps<{
    noPadding?: boolean;
    hasContent?: boolean;
    side?: 'left' | 'bottom' | 'top' | 'right';
    triggerAs?: string;
    sideOffset?: number;
  }>(),
  {
    noPadding: false,
    hasContent: true,
    side: undefined,
    triggerAs: 'span',
    sideOffset: 5,
  },
);
</script>
